import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Lead } from '../models/lead.model';
import { DrawerRegistryService } from '../../../shared/services/drawer-registry.service';

export interface LeadDrawerOptions {
  leadId?: number;
  contactId?: number;
  contactName?: string;
  companyId?: number;
  companyName?: string;
}

@Injectable({ providedIn: 'root' })
export class LeadDrawerService {
  private readonly registry = inject(DrawerRegistryService);
  private readonly state$ = new BehaviorSubject<{ isOpen: boolean; options: LeadDrawerOptions }>({
    isOpen: false,
    options: {}
  });

  private readonly leadSaved$$ = new Subject<Lead>();

  readonly state = this.state$.asObservable();
  readonly leadSaved$ = this.leadSaved$$.asObservable();

  open(options: LeadDrawerOptions = {}): void {
    if (!this.state$.value.isOpen) this.registry.opened();
    this.state$.next({ isOpen: true, options });
  }

  close(): void {
    if (this.state$.value.isOpen) this.registry.closed();
    this.state$.next({ isOpen: false, options: {} });
  }

  notifySaved(lead: Lead): void {
    this.leadSaved$$.next(lead);
  }
}
